const { Howl, Howler } = require('howler')
Howler.volume = 0.6

export const bgm = {
  play () {}
}
/*
new Howl({
  src: [require('./SFX/BGM_Edit.mp3')]
})
*/

export const absorb = new Howl({
  src: [require('./SFX/sfx_absorb.mp3')]
})

export const click = new Howl({
  src: [require('./SFX/sfx_click_edit.mp3')]
})

export const correct = new Howl({
  src: [require('./SFX/sfx_correct.mp3')]
})

export const error = new Howl({
  src: [require('./SFX/sfx_error.mp3')]
})

export const gohome = new Howl({
  src: [require('./SFX/sfx_return-logoutandhome.mp3')]
})
